module.exports = __webpack_public_path__ + "static/media/suita_button_gochirameru.4f9c0872.png";